// extracted by mini-css-extract-plugin
module.exports = {"spinner":"avelios-spinner_spinner__0U_XF","ldsDefaultWrapper":"avelios-spinner_ldsDefaultWrapper__IYIMX","ldsRipple":"avelios-spinner_ldsRipple__7jWhw"};